module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login__logo"
  }, [_vm._v("健脑云平台")]), _vm._v(" "), _c('div', {
    staticClass: "login__form"
  }, [_c('div', {
    staticClass: "login__title"
  }, [_c('div', [_vm._v("您好  " + _vm._s(_vm.store.account.name))]), _vm._v(" "), _c('div', [_vm._v("为保证账号安全性及密码找回请短信激活并重新设置密码")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.store.account.mobile))])]), _vm._v(" "), _c('form', {
    staticClass: "login__body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationCode),
      expression: "verificationCode"
    }],
    staticClass: "textbox__login",
    attrs: {
      "type": "textbox",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verificationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    style: (_vm.styleObject),
    attrs: {
      "id": "hi",
      "disabled": _vm.hasGetCode
    },
    on: {
      "click": _vm.getVerificationCode
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "textbox__login",
    attrs: {
      "type": "textbox",
      "placeholder": "6-16位字母数字混合新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "textbox__login",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('li', {
    staticClass: "textbox__login error"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _c('button', {
    staticClass: "button__login",
    attrs: {
      "type": "submit",
      "disabled": ""
    },
    on: {
      "click": _vm.activateAccount
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_vm._v("激活账号")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c038598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/activation.vue
// module id = 1013
// module chunks = 2